import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAncillaryCategory } from '../../graphql/queries/ancillaryCategory';
import Header from '../common/Header';

const AncillaryCategory = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="ancillaryCategories.show.title"
        linkTo={`/admin/ancillary_categories/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getAncillaryCategory(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { ancillaryCategory } = data;
            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('ancillaryCategories.attributes.identifier')}
                        </div>
                        <div className="common-show__infos--value">
                          {ancillaryCategory.identifier}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default AncillaryCategory;
